module.exports = __webpack_public_path__ + "img/1499579051.57307346.jpg";